module.exports = __webpack_public_path__ + "static/img/car.bcd34079.png";